module.exports = __webpack_public_path__ + "static/media/mediterranean-categories.f56191c5.jpg";